module.exports = __webpack_public_path__ + "static/media/carousel-arrow-left.fb3e2aab.svg";